<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.reports'), $t('reports.omsSalePerformance')]"
      >
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="110px"
      >
        <el-form-item
          :label="$t('settlement.dateType')"
          :prop="'_dateType'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateType')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-radio-group size="small" v-model="searchForm._dateType">
            <el-radio label="createAt">{{ $t("text.createAt") }}</el-radio>
            <el-radio label="finishAt">{{ $t("delivery.deliverAt") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />

        <el-form-item
          :label="$t('settlement.dateRange')"
          :prop="'_dataRange'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('settlement.dateRange')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="_dataRange"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />
        <el-form-item :label="'统计方式'">
          <el-radio-group v-model="searchForm.type" @change="selectType">
            <el-radio label="user"> 人员 </el-radio>
            <el-radio label="shop"> 店铺 </el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item
          class="mgl20"
          v-if="searchForm.type == 'user' && users.length != 0"
        >
          <el-checkbox
            v-model="checkAllUserDF"
            :indeterminate="isIndeterminateUser"
            class="mgb10"
            @change="handleCheckAllChangeUser"
            >{{ $t("action.checkAll") }}</el-checkbox
          >
        </el-form-item>
        <el-form-item
          :label="$t('salesTarget.userName')"
          v-if="searchForm.type == 'user' && users.length != 0"
        >
          <el-checkbox-group
            v-model="searchForm.ownerIds"
            @change="handleCheckedChangeUser"
          >
            <el-checkbox v-for="user of users" :key="user.id" :label="user.id">
              <span v-if="user.voidAt != null" class="deleted">
                {{ user.name }}
              </span>
              <span v-else>{{ user.name }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          class="mgl20"
          v-if="searchForm.type == 'shop' && shops.length != 0"
        >
          <el-checkbox
            v-model="checkAllShopDF"
            :indeterminate="isIndeterminateShop"
            class="mgb10"
            @change="handleCheckAllChangeShop"
            >{{ $t("action.checkAll") }}</el-checkbox
          >
        </el-form-item>
        <el-form-item
          :label="$t('menu.shops')"
          v-if="searchForm.type == 'shop' && shops.length != 0"
        >
          <el-checkbox-group
            v-model="searchForm.shopIds"
            @change="handleCheckedChangeShop"
          >
            <el-checkbox
              v-for="(shop, index) of shops"
              :key="index"
              :label="shop.id"
              >{{ shop.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="ownerName"
          :title="
            searchForm.type == 'shop'
              ? $t('menu.shops')
              : $t('salesTarget.userName')
          "
          min-width="80"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="saleAmountDetail(row)">
              <span v-if="searchForm.type == 'user'">{{ row.ownerName }}</span>
              <span v-if="searchForm.type == 'shop'">{{ row.shopName }}</span>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="countTotal"
          :title="$t('report.orderQty')"
          min-width="80"
        />
        <vxe-table-column
          field="productNoQty"
          :title="$t('report.productQty')"
          min-width="80"
        />
        <vxe-table-column
          field="qtyTotal"
          :title="$t('report.qty')"
          min-width="80"
        />
        <vxe-table-column
          field="saleAmount"
          :title="$t('bargain.saleAmount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.saleAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" :title="'成交额-产品'" min-width="110">
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.amount }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="extraCharge"
          :title="'成交额 - 附加费'"
          min-width="110"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.extraChargeAmount }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="actualReceive2"
          :title="$t('bargain.actualReceive2')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="payAmountDetail(row, 'normal')">
              <currency :code="row.currency"></currency>
              {{ row.payAmount }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ignoreAmount"
          :title="$t('payment.ignoreAmount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="payAmountDetail(row, 'ignore')">
              <currency :code="row.currency"></currency>
              {{ row.ignorePayAmount }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="diffAmount"
          :title="$t('bargain.diffAmount')"
          min-width="110"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="diffAmountDetail(row)">
              <currency :code="row.currency"></currency>
              {{ row.diffAmount }}
            </span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Currency from "@/components/Currency";

import User from "@/api/user";
import Shop from "@/api/shop";
import Order from "@/api/order";

export default {
  mixins: [page],
  components: { DateRange, Currency },
  data() {
    return {
      searchForm: {
        createAtStartAt: null,
        createAtEndAt: null,
        finishAtStartAt: null,
        finishAtEndAt: null,
        shopIds: [],
        ownerIds: [],
        type: "user",
        _dateType: "createAt",
        _dataRange: null,
        _dataRangeStartAt: null,
        _dataRangeEndAt: null,
      },
      users: [],
      shops: [],
      //
      records: [],
      totals: [],
      loading: false,
      //
      checkAllUserDF: false,
      isIndeterminateUser: false,
      //
      checkAllShopDF: false,
      isIndeterminateShop: false,
    };
  },

  created() {
    const self = this;
    axios.all([Shop.findByTenantId(), User.findByTenantId()]).then(
      axios.spread(function (shops, users) {
        if (shops.status == 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        if (users.status == 200) {
          const allUsers = users.data.filter(
            (u) => (u.voidAt == null && u.authorize == true) || u.voidAt != null
          );
          if (self.Permit.currentUser().admin === true) {
            self.users = allUsers;
          } else {
            self.users = allUsers.filter((u) =>
              JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
            );
          }
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    selectType() {
      if (this.searchForm.type == "user") {
        this.checkAllShopDF = false;
        this.isIndeterminateShop = false;
        this.searchForm.shopIds = [];
      }
      if (this.searchForm.type == "shop") {
        this.checkAllUserDF = false;
        this.isIndeterminateUser = false;
        this.searchForm.ownerIds = [];
      }
    },
    //  全选 user
    handleCheckAllChangeUser(val) {
      this.searchForm.ownerIds = val ? this.users.map((u) => u.id) : [];
    },
    handleCheckedChangeUser(value) {
      const checkedCount = value.length;
      this.checkAllUserDF = checkedCount === this.users.map((u) => u.id).length;
      this.isIndeterminateUser =
        checkedCount > 0 && checkedCount < this.users.map((u) => u.id).length;
    },
    //  全选 shop
    handleCheckAllChangeShop(val) {
      this.searchForm.shopIds = val ? this.shops.map((s) => s.id) : [];
    },
    handleCheckedChangeShop(value) {
      const checkedCount = value.length;
      this.checkAllShopDF = checkedCount === this.shops.map((s) => s.id).length;
      this.isIndeterminateShop =
        checkedCount > 0 && checkedCount < this.shops.map((s) => s.id).length;
    },
    payAmountDetail(row, type) {
      const self = this;
      let obj = self.computeDetailSearchObj(row);
      Vue.set(obj, "type", type);
      self.$router.push({
        name: "fnReportsReportsOmsSalePerformancePayAmountDetail",
        query: obj,
      });
    },
    saleAmountDetail(row) {
      const self = this;
      self.$router.push({
        name: "fnReportsReportsOmsSalePerformanceSaleAmountDetail",
        query: self.computeDetailSearchObj(row),
      });
    },
    diffAmountDetail(row) {
      const self = this;
      self.$router.push({
        name: "fnReportsReportsOmsSalePerformanceDiffDetail",
        query: self.computeDetailSearchObj(row),
      });
    },
    computeDetailSearchObj(row) {
      const self = this;
      self.searchForm.createAtStartAt = null;
      self.searchForm.createAtEndAt = null;
      self.searchForm.finishAtStartAt = null;
      self.searchForm.finishAtEndAt = null;
      if (self.searchForm._dateType == "createAt") {
        self.searchForm.createAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.createAtEndAt = self.searchForm._dataRangeEndAt;
      }
      if (self.searchForm._dateType == "finishAt") {
        self.searchForm.finishAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.finishAtEndAt = self.searchForm._dataRangeEndAt;
      }
      let obj = {
        createAtStartAt: self.searchForm.createAtStartAt,
        createAtEndAt: self.searchForm.createAtEndAt,
        finishAtStartAt: self.searchForm.finishAtStartAt,
        finishAtEndAt: self.searchForm.finishAtEndAt,
        ownerId: null,
        shopId: null,
      };
      if (self.searchForm.type == "user") {
        obj.ownerId = row.ownerId;
        obj.shopId = null;
      }
      if (self.searchForm.type == "shop") {
        obj.ownerId = null;
        obj.shopId = row.shopId;
      }
      return Util.deleteObjValueIsNull(obj);
    },
    //
    download() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Order.salesRevenueReportExportExcel(self.combineParams()).then(function (
        res
      ) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.checkedRows = [];
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },
    search() {
      const self = this;
      if (self.searchForm._dataRangeStartAt == null) {
        self.$message({
          message: "请选择日期范围",
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Order.salesRevenueReport(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    combineParams() {
      const self = this;
      self.searchForm.createAtStartAt = null;
      self.searchForm.createAtEndAt = null;
      self.searchForm.finishAtStartAt = null;
      self.searchForm.finishAtEndAt = null;
      if (self.searchForm._dateType == "createAt") {
        self.searchForm.createAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.createAtEndAt = self.searchForm._dataRangeEndAt;
      }
      if (self.searchForm._dateType == "finishAt") {
        self.searchForm.finishAtStartAt = self.searchForm._dataRangeStartAt;
        self.searchForm.finishAtEndAt = self.searchForm._dataRangeEndAt;
      }
      let params = {};
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>